var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowsType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-57.1%",
    y: "-57.1%",
    width: "214.3%",
    height: "214.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-ux-ybzfnqe-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00867116044   0 0 0 0 1   0 0 0 0 0.885037077  0 0 0 0.304127513 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connections",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181.000000, -187.000000)",
    fill: "#55BBB0",
    fillRule: "nonzero",
    id: "Windows_logo_-_2012"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-ux-ybzfnqe-1)",
    transform: "translate(196.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.95541983 L14.3034068,3.01352817 L14.3098196,16.767795 L0.0132264529,16.8489069 L0,4.95541983 Z M14.2965932,18.3524745 L14.3078156,32.1187282 L0.0112224449,30.1592557 L0.0104208417,18.2601747 L14.2965932,18.3524745 Z M16.0304609,2.75940408 L34.9955912,0 L34.9955912,16.592785 L16.0304609,16.7430219 L16.0304609,2.75940408 Z M35,18.4819339 L34.9955912,35 L16.0304609,32.331697 L16.004008,18.4511673 L35,18.4819339 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsType);
export default __webpack_public_path__ + "static/media/windows-type.3cf41c88d997ae16253ab8ef91e86810.svg";
export { ForwardRef as ReactComponent };